import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import {
    BehaviorSubject,
    combineLatest,
    Observable,
    shareReplay,
    tap,
} from "rxjs";
import { FlightModel } from "@/_models/flight/flight.model";
import { UserService } from "@/_services";
import { Flight, MitigationState } from "@/_models";
import { expandingFabAnimations } from "@/_utility/animations";
import { AsyncPipe, CommonModule, NgClass } from "@angular/common";
import { PaginatorModule } from "primeng/paginator";
import { MessagesModule } from "primeng/messages";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { HomeTaskCardComponent } from "@/components/home/home-task-card/home-task-card.component";
import { CombinedTask } from "@/_models/combinedTask.interface";
import { PromotionTaskCardComponent } from "../promotion-task-card/promotion-task-card.component";
import { IssueTaskCardComponent } from "../issue-task-card/issue-task-card.component";
import { Message } from "primeng/api";
import { TaskCardComponent } from "../task-card/task-card.component";
import { AuditTaskCardComponent } from "../audit-task-card/audit-task-card.component";
import { CombinedTasksService } from "@/_services/combined-task.service";
import { isAsapAccount } from "@/_models/account.interface";

@Component({
    selector: "app-home-task-list",
    standalone: true,
    imports: [
        AsyncPipe,
        PaginatorModule,
        SharedComponentsModule,
        HomeTaskCardComponent,
        PromotionTaskCardComponent,
        IssueTaskCardComponent,
        TaskCardComponent,
        AuditTaskCardComponent,
        NgClass,
        CommonModule,
    ],
    templateUrl: "./home-task-list.component.html",
    styleUrls: ["./home-task-list.component.scss"],
    animations: [expandingFabAnimations],
})
export class HomeTaskListComponent implements OnInit {
    @Output() onFilterMenuToggle = new EventEmitter<void>();
    @ViewChild("taskArea") taskArea: ElementRef;

    taskList$: Observable<FlightModel[]>;
    secontTaskList$: Observable<CombinedTask[]>;
    isLoading$: Observable<boolean>;
    private reload$ = new BehaviorSubject<void>(undefined);

    get pageSize(): number {
        return this.homeService.pageSize;
    }

    get total(): number {
        return this.homeService.total;
    }

    get currentPage(): number {
        return this.homeService.currentPage;
    }

    messages: Message[] | undefined;

    isAsap: boolean = false;

    constructor(
        private homeService: CombinedTasksService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.messages = [
            { severity: "warn", detail: "You have past due items to address." },
        ];
        this.secontTaskList$ = this.homeService.loadCombinedTasks();
        this.isLoading$ = this.homeService.isLoading$;

        // Determine ASAP account mode
        this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay(1))
            .subscribe((u) => (this.isAsap = isAsapAccount(u?.account)));
    }

    onPageChange(event: any) {
        const pageNumber = event.first / event.rows;
        this.homeService.setPage(pageNumber);
    }

    reload() {
        this.reload$.next();
    }
}
